<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">AUTHOR’S NOTE</h1>
<p class="nonindent">Yes, I know. We’re using the American spelling of Valor in the title and yet the stories use Canadian/UK spelling. Trust me, I’d have rather been able to use Canadian/UK spelling on the cover too but we’re trying to get it to match up with the new ebook series where we couldn’t change the interior to Canadian/UK spelling without having to charge you a whole lot more for each book. Which we didn’t want to do. Seriously, we didn’t. My biggest defining characteristic after Canadian is…um, frugal. Yeah, let’s call it frugal.</p>
<p class="indent">But I could use Canadian/UK spellings for these short stories because they’re a lot easier to change than eight books first published with US spelling. And I didn’t have to change “Long Time Passing,” because I wrote it for this collection.</p>
<p class="indent">Anyway, we’re aware. And we recognize some people might find it a bit weird. But we saved you money, so yay.</p>
<p class="indent">“Not That Kind of War,” “First In,” and “To Dust We Shall Return” all happen before the novels. Yes, I know most of you will be able to figure that out on your own, but in case someone new has wandered in, it’s only polite to mention it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?3642d07a